import { 
    Wind, Hand, Heart, Eye, Feather, Snowflake, Waves, 
    GripVertical, Users, Sparkles, Globe 
} from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

// Tool type metadata
export const TOOL_TYPE_CONFIG = {
    breath: { label: 'Breath', color: '#1D6B6B', bgColor: '#7D8E95', icon: Wind },
    grounding: { label: 'Grounding', color: '#7D8E95', bgColor: '#7D8E95', icon: Hand },
    somatic: { label: 'Body Awareness', color: '#7D8E95', bgColor: '#7D8E95', icon: Hand },
    bls: { label: 'Tapping', color: '#7D8E95', bgColor: '#7D8E95', icon: Heart },
    visual_bls: { label: 'Eye Movement', color: '#7D8E95', bgColor: '#7D8E95', icon: Eye },
    anchoring: { label: 'Anchoring', color: '#7D8E95', bgColor: '#E2D5E8', icon: Heart },
    reflection: { label: 'Reflection', color: '#7D8E95', bgColor: '#FFBB98', icon: Feather },
    closing: { label: 'Closing', color: '#1D6B6B', bgColor: '#7D8E95', icon: Heart },
    micro_reset: { label: 'Micro-Reset', color: '#7D8E95', bgColor: '#7D8E95', icon: Hand },
    orientation: { label: 'Orientation', color: '#1D6B6B', bgColor: '#7D8E95', icon: Eye },
    touch: { label: 'Touch', color: '#7D8E95', bgColor: '#E2D5E8', icon: Hand },
    softening: { label: 'Softening', color: '#7D8E95', bgColor: '#7D8E95', icon: Feather },
};

export const PATH_ICONS = {
    Snowflake: Snowflake,
    Wind: Wind,
    Waves: Waves,
    Heart: Heart,
    Zap: GripVertical,
};

export const PAGE_ICON_MAP = {
    Heart,
    Users,
    Sparkles,
    Globe,
};

export const TAB_LIST = [
    { id: 'pages', label: 'Pages' },
    { id: 'blog', label: 'Blog' },
    { id: 'testimonials', label: 'Testimonials' },
    { id: 'tools', label: 'Tools' },
    { id: 'meditations', label: 'Meditations' },
    { id: 'voice', label: 'Voice Settings' },
    { id: 'paths', label: 'Paths' },
    { id: 'assessment', label: 'Assessment' },
    { id: 'emotions', label: 'Emotions' },
    { id: 'education', label: 'Education' },
    { id: 'scripts', label: 'Scripts' },
    { id: 'triggers', label: 'Triggers' },
    { id: 'patterns', label: 'Patterns' },
    { id: 'checkin', label: 'Check-in' },
    { id: 'repair', label: 'Repair' },
    { id: 'disclaimer', label: 'Disclaimer' },
    { id: 'pricing', label: 'Pricing Tiers' },
    { id: 'subscribers', label: 'Subscribers' },
    { id: 'support', label: 'Support' },
];
